import "./App.css";
import Containers from "./containers";

const App = () => {
  return (
    <div className="App">
      <Containers />
    </div>
  );
};

export default App;
